module.exports = __webpack_public_path__ + "static/media/salesIllustrate.106baf19.svg";